import SimulateService from "../../../service/SimulateService"
import { getApiFailureMessage, showToastMessage } from "../../../utils/commonFunctions";
import { OrbitalInsightsResponseType } from "./orbital-insights-type";

export const getOrbitalInsights = async (missionId: string, scenarioId: string, showError = true): Promise<OrbitalInsightsResponseType | null> => {
    try {
        const response = await SimulateService.getOrbitalInsights(missionId, scenarioId);
        // Ensure the API response is an array
        return response?.data?.data || null;
    } catch (error) {
        if (showError) {
            const message = getApiFailureMessage(error, 'Fetch');
            showToastMessage('error', message);
        }
        return null;
    }
};
